import React from "react";
import { Table, TableHead, TableBody, TableCell, TableRow, Grid, TableContainer, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";
import moment from "moment";

const tableCellStyle = { color: "#222" };

export default function PlannedMaintenanceTable(props) {
    const { t } = useTranslation("translation");

    return (
        <Grid container item md={12}>
            <Grid item xs={1} sm={3} md={2}></Grid>
            {/*Empty grid for alignment*/}
            <Grid item xs={10} sm={6} md={8}>
                <div style={{ overflow: "auto", height: "700px" }}>
                    <Table aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">{t("ID")} </TableCell>
                                <TableCell align="center">{t("StatusDesc")} </TableCell>
                                <TableCell align="center">{t("AreaCode")} </TableCell>
                                <TableCell align="center">{t("CostCenterCode")} </TableCell>
                                <TableCell align="center">{t("EquipmentDetailCode")} </TableCell>
                                <TableCell align="center">{t("EquipmentName")} </TableCell>
                                <TableCell align="center">{t("PoolName")} </TableCell>
                                <TableCell align="center">{t("OrderNote")} </TableCell>
                                <TableCell align="center">{t("PlannedDate")} </TableCell>
                                <TableCell align="center">{t("Shifts")} </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.plannedMaintenanceExcel.map((row) => (
                                <TableRow style={{ background: row.hasWarning ? "#FF9089" : "aliceblue" }}>
                                    <TableCell sx={tableCellStyle} align="center">{row.id}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.statusDesc}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.areaCode}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.costCenterCode}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.equipmentDetailedCode}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.equipmentName}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.poolName}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.orderNote}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{moment(row.plannedDate).format("DD.MM.YYYY")}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.shiftNo}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Grid>
            <Grid container xs={1} sm={3} md={4}>
                {props.warningList.length > 0 && props.plannedMaintenanceExcel.length > 0 ? (
                    <>
                        <Grid item md={2}></Grid>
                        <Grid item md={8}>
                            <TableContainer component={Paper} style={{ backgroundColor: "#FF9089" }}>
                                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="center">{t("Line")}</TableCell>
                                            <TableCell align="center">{t("Warnings")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {props.warningList.map((row) => (
                                            <TableRow>
                                                <TableCell sx={tableCellStyle} align="center">{row.rowNumber}</TableCell>
                                                <TableCell sx={tableCellStyle} align="center">{row.message}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                        <Grid item md={2}></Grid>
                    </>
                ) : null}
            </Grid>{" "}
            {/*Empty grid for alignment*/}
        </Grid>
    );
}
